export default __webpack_public_path__ + "static/media/network.3e13f669.svg";